import { Component } from 'react';

import _ from 'lodash';

class EditableComponent extends Component {
    onFieldChange = (fieldName, mapFn) => (e) => {
        const value = mapFn ? mapFn(e) : e.target.value;
        const state = {};
        _.set(state, fieldName, value);
        this.setState(state);
    }
}

export default EditableComponent;



// WEBPACK FOOTER //
// ./src/arteia-js/components/EditableComponent/index.js